import { observer } from 'mobx-react-lite';
import React from 'react';
import { Await } from '../../../components/Await';
import {
    TrainingContentType,
    TrainingDataType,
    useSanity,
} from '../../../lib/landingPage';
import { Spin } from '../../../components/Spin';
import { useRouteMatch } from 'react-router-dom';
import { classes, useRedirect } from '../../../lib';
import { TrainingSearchBar } from '../../../components/landingPage/training/TrainingSearchBar';
import { TrainingMenu } from '../../../components/landingPage/training/TrainingMenu';
import Styles from './TrainingPage.module.less';
import { TrainingContentContainer } from '../../../bound/landingPage/TrainingContentContainer';
import {
    HOME_TRAINING_SLUG,
    TRAINING_URL,
    getTrainingCurrentSlug,
} from '../../../lib/landingPage/training';
import { TrainingLogoBar } from '../../../components/landingPage/training/TrainingLogoBar';

type TrainingPageResolvedProps = {
    trainingMenu: TrainingDataType;
    trainingContents: TrainingContentType[];
};

const TrainingPageResolved = observer(
    ({ trainingMenu, trainingContents }: TrainingPageResolvedProps) => {
        const match = useRouteMatch({
            path: TRAINING_URL(),
            exact: true,
        });

        const redirect = useRedirect();

        if (match) {
            redirect(`${TRAINING_URL()}/${HOME_TRAINING_SLUG}`);
        }

        return (
            <div className="vertical">
                <TrainingLogoBar trainingMenu={trainingMenu} />
                <TrainingSearchBar
                    trainingMenu={trainingMenu}
                    currentSlug={getTrainingCurrentSlug()}
                />

                <div className="horizontal">
                    <TrainingMenu trainingMenu={trainingMenu} />
                    <div className={Styles.contentContainer}>
                        <TrainingContentContainer
                            trainingContents={trainingContents}
                        />
                    </div>
                </div>
            </div>
        );
    }
);

export const TrainingPage = observer((): JSX.Element => {
    const sanityStore = useSanity();

    return (
        <Await
            views={{
                trainingContents: sanityStore.asyncRentalTrainingContent,
                trainingMenu: sanityStore.asyncRentalTraining,
            }}
            resolved={TrainingPageResolved}
            pending={() => (
                <Spin
                    className={classes(
                        'horizontal center-middle',
                        Styles.spinner
                    )}
                />
            )}
        />
    );
});
